/* eslint max-statements: 0 */
'use strict';

import React, { useEffect, useState, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import get from 'lodash.get';

// Legacy Components
import { ProgressCircle } from 'acq-components/lib/base-components/LoadingIndicator/ProgressCircle/ProgressCircle';

// Components
import CardTrayHolder from 'page_modules/business-vac/components/CardTray/CardTrayHolder';
import RABBanner from 'src/universal/components/RABBanner';
import CardSelector from 'page_modules/business-vac/components/CardSelector';
import Breadcrumbs from 'src/universal/components/Breadcrumbs';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import SuppCardsModal from 'src/universal/components/SuppModal';
import DcfBanner from 'src/universal/components/DcfBanner';
import { pznPageIds } from 'src/universal/components/PZN/config';
import { Sticky } from '@americanexpress/aqx-components';
import Hero from 'page_modules/business-vac/components/Hero/index.js';
import PillboxFilter from 'page_modules/business-vac/components/PillboxFilter/';
import PillboxStickyItemWrap from 'page_modules/business-vac/components/PillboxFilter/StickyItemWrap';
import CardTiles from '../CardTiles';
import KabbageBanner from 'page_modules/business-vac/components/KabbageBanner/index.js';
import ViewMyAccount from '../ViewMyAccount';
import DynamicAppModal from 'src/universal/components/DynamicApp/DynamicAppModal';
import {
  DynamicAppModalContext,
  ModalButtonRefContext
} from 'src/universal/components/DynamicApp/redux';
import { FAQ } from 'src/universal/components/FAQ';
import TrackExperimentImpression from 'src/universal/components/TrackExperimentImpression';
import FooterLegalCopy from 'page_modules/business-vac/components/FooterLegalCopy';
import ApplyByPhoneButton from 'page_modules/business-vac/components/ApplyByPhoneButton/index';
import CarouselCardList from 'page_modules/business-vac/components/CardListCarousel';
import SeoCategory from 'page_modules/business-vac/components/SeoCategory/index.js';

// Selectors
import {
  getMemberCardShortNames,
  isUserLoggedIn
} from 'src/universal/redux/cardMemberInfo';
import {
  getActiveFilterCards,
  getActiveFilterLabel
} from 'src/universal/redux/cardsFilter';
import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import {
  getSelectedCompareCards,
  dispatchAddCardToCompare,
  dispatchRemoveCardFromCompare,
  dispatchPreselectedCardsArrived
} from 'src/universal/redux/compareCardsTray';
import { getCardListData } from 'src/universal/redux/compareCardsTray.js';
import { shouldShowDynamicAppVac } from 'page_modules/business-vac/redux';
import {
  hasPznDataArrived,
  getPznSpecialOfferDtmInfo
} from 'src/universal/redux/pznData';
import { getPageFeatureFlags } from 'src/universal/redux/page';
import { isG169Variant } from 'src/universal/components/Experiments/G169/redux';
import { isG176Variant } from 'src/universal/components/Experiments/G176/redux';
import {
  isG174Experiment,
  getG174ActiveFilterCards,
  getG174ActiveFilterLabel
} from 'src/universal/components/Experiments/G174/redux.js';

// Utils
import dtmEvents from 'service_modules/models/dtm-tagging';
import { isBrowser } from 'acq-utils/lib/misc';
import OfferGatingForm from 'page_modules/utils/offer-gating';

// Styles
import vacRABBannerStyles from 'src/universal/components/RABBanner/__styles__/vacRabBanner.scss?modules';
import ProgressCircleStyles from 'acq-components/lib/base-components/LoadingIndicator/ProgressCircle/styles/us-commercial/styles.scss?modules';
import faqStyles from 'page_modules/business-vac/__styles__/faqStyle.scss?modules';
import 'src/universal/components/MGMWidget/__styles__/vacHeroWidgetStyles.scss';

// Legacy Styles
import 'core_modules/aexp-modal/templates/aexp-pzn-expiry-modal/aexp-pzn-expiry-modal.scss';
import 'core_modules/aexp-modal/templates/aexp-amazon-redirect-modal/aexp-amazon-redirect-modal.scss';
import 'theme_modules/open-gcp/pages/business-credit-cards-v2/vac-page-v2.scss';
import 'theme_modules/open-gcp/pages/card-details/card-details-spacers.scss';

// Expirement Dependencies
import { getDynAppModalContent } from 'src/universal/components/DynamicApp/redux';

const BusinessCreditCardsTemplate = React.memo(function BusinessCreditCardsTemplate({
  pageData,
  bauActiveFilterLabel,
  isCmLoggedIn,
  selectedCards,
  dynAppModalContent,
  shouldShowDynamicApp,
  comparedCards,
  cardShortNames,
  bauFilterCards,
  pznSpecialOfferDtmInfo,
  staticOrderCards,
  pznArrived,
  setCardsInCompareTray,
  isG169,
  g174ActiveCards,
  isG174,
  g174ActiveLabel,
  isG176
}) {
  const activeFilterCards = isG174 ? g174ActiveCards : bauFilterCards;
  const activeFilterLabel = isG174 ? g174ActiveLabel : bauActiveFilterLabel;
  useEffect(() => {
    setCardsInCompareTray();
  }, []);
  const [needCardPicker, setNeedCardPicker] = useState(false);
  const [showSuppModal, setShowSuppModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filterTilesContainerRef = useRef(null);
  const [buttonRef, setButtonRef] = useState(null);
  const dynAppButtonRef = { buttonRef, setButtonRef };
  const toggleDynamicAppModalOpen = useCallback(
    () => setIsModalOpen(prev => !prev),
    []
  );

  const doDtmDispatch = actionObj => {
    if (!actionObj.dtmTag.eventAction) {
      actionObj.dtmTag.eventAction = 'Click';
    }
    dtmEvents.dispatch(actionObj);
  };

  const handleToggleSuppModal = e => {
    e?.stopPropagation();
    setShowSuppModal(!showSuppModal);
  };

  const onCompareTrayEmptyItemClick = () => {
    setNeedCardPicker(true);
    const {
      cardPickerForm: { dtmTag }
    } = pageData;
    doDtmDispatch({ type: 'DTM_CLICK', dtmTag: dtmTag });
  };
  const getInnerWidth = () => (isBrowser() ? window.innerWidth : undefined);

  const getMaxCountInCompareTray = () => {
    const maxCardsAllowedInTray = 3;
    const maxCardsAllowedInTrayMobile = 2;
    const compareTrayMobileBreakpoint = 414;
    const winWidth = getInnerWidth();

    if (!isNaN(winWidth) && winWidth <= compareTrayMobileBreakpoint) {
      return maxCardsAllowedInTrayMobile;
    }
    return maxCardsAllowedInTray;
  };

  const buildCardListForTray = () => {
    const list = [null, null, null];

    for (let i = 0; i < comparedCards.length; i++) {
      list[i] = comparedCards[i];
    }

    return list;
  };

  const closeCardPickerModal = () => {
    setNeedCardPicker(false);

    const {
      closeCardPicker: { dtmTag }
    } = pageData;
    doDtmDispatch({ type: 'DTM_CLICK', dtmTag: dtmTag });

    const cardList = buildCardListForTray();
    const selectedList = cardList.filter(c => c !== null);
    if (selectedList.length > 1) {
      setTimeout(() => {
        const compareButton = document.querySelector('.action-button');
        if (compareButton) {
          compareButton.focus();
        }
      }, 1200);
    }
  };

  const updateCardMemberTiles = item => {
    if (cardShortNames.includes(item.shortName)) {
      item.isCardMemberCard = true;
      item.addSupUser = pageData.addSupUser;
    }
    return item;
  };

  let matchingCards = 0;

  const filteredCards = pageData.cards.map(card => {
    const shouldDisplayCard = activeFilterCards.indexOf(card.shortName) > -1;

    card.isInCurrentFilter = shouldDisplayCard;
    card.firstCard = false;
    if (shouldDisplayCard) {
      matchingCards += 1;
    }
    if (shouldDisplayCard && matchingCards === 2) {
      card.firstCard = true;
    }
    const onClick = card?.applyButton?.onClick ?? (() => {});
    const onClickWrapper = e => {
      return onClick(e);
    };
    card.applyButton.onClick = onClickWrapper;
    updateCardMemberTiles(card);
    return card;
  });

  const filteredShortNames = filteredCards.reduce((acc, curr) => {
    if (curr.isInCurrentFilter) {
      acc.push(curr.shortName);
    }
    return acc;
  }, []);

  let needCardTray;
  let maxSelectedCardsReached = false;

  if (selectedCards.length > 0) {
    needCardTray = true;
    maxSelectedCardsReached = selectedCards.length >= getMaxCountInCompareTray();
  }

  const cardTileMobileProps = {
    cardList: filteredCards,
    pageData
  };

  const listTitle =
    activeFilterLabel && activeFilterCards.length
      ? `${activeFilterLabel} (${activeFilterCards.length})`
      : '';

  const vacClassNames = clsx(
    'sections-container',
    'vac-page-v2',
    { 'tray-visible': needCardTray },
    { 'max-reached': maxSelectedCardsReached },
    { isG169: isG169 },
    { isG176: isG176 },
    { needCardPicker: needCardPicker }
  );

  const filteredListHeaderClassNames = clsx('filtered-list-header', {
    'contains-breadcrumbs': true
  });

  const faqContent = pageData?.faq || {};

  const heroProps = {
    handleToggleSuppModal: handleToggleSuppModal
  };

  const isLoggedInCM = isCmLoggedIn;

  useEffect(
    () => {
      if (needCardPicker) {
        window.scrollTo(0, 0);
      }
    },
    [needCardPicker]
  );

  return (
    <div
      id="business-credit-cards-v3"
      className={clsx(vacClassNames, {
        isLoggedInCM: isLoggedInCM
      })}
    >
      <DynamicAppModalContext.Provider value={toggleDynamicAppModalOpen}>
        <ModalButtonRefContext.Provider value={dynAppButtonRef}>
          <TrackExperimentImpression experimentName="GCS-158-Vac-Multiple-Cards" />
          <TrackExperimentImpression experimentName="GCS-147-DynamicApp" />
          <TrackExperimentImpression experimentName="GCS159-Mobile-VAC-CardTile" />
          <TrackExperimentImpression experimentName="GCS160-LTO-Badge" />
          <TrackExperimentImpression experimentName="GCS-161-Compare-Tray-VAC" />
          <TrackExperimentImpression experimentName="GCS-162-Compare-Banner-VAC" />
          <TrackExperimentImpression experimentName="GCS-169-VAC-Category-Optimization" />
          <TrackExperimentImpression experimentName="GCS-172-VAC-Card-Tile-Revamp" />
          <TrackExperimentImpression experimentName="GCS-174-CM-Recommended-Filter" />
          <TrackExperimentImpression experimentName="GCS-176-VAC-Dynamic-Hero" />
          <TrackExperimentImpression experimentName="GCS-186-SBS-AHA" />
          <OfferGatingForm />
          {(pznSpecialOfferDtmInfo || {}).needEvent && (
            <LazyScrollMetricTracker
              scrollDtm={pznSpecialOfferDtmInfo.dtmObj}
              startTrackingAfterPznArrival={true}
            />
          )}
          {needCardPicker && <CardSelector toggle={closeCardPickerModal} />}
          <div style={{ display: needCardPicker ? 'none' : 'block' }}>
            <ViewMyAccount />
            {shouldShowDynamicApp && (
              <DynamicAppModal
                modal={isModalOpen}
                toggle={toggleDynamicAppModalOpen}
                content={dynAppModalContent}
                buttonRef={dynAppButtonRef.buttonRef}
              />
            )}
            <Hero {...heroProps} />
            <div
              className="filter-card-tile-container"
              ref={filterTilesContainerRef}
            >
              <Sticky.Container>
                <PillboxStickyItemWrap isLoggedInCM={isLoggedInCM}>
                  <PillboxFilter containerRef={filterTilesContainerRef} />
                </PillboxStickyItemWrap>
                {staticOrderCards || pznArrived ? (
                  <>
                    <CarouselCardList />
                    <div className="card-tile-section-wrap">
                      <div className="section-background list-header-wrap">
                        <h2 className={filteredListHeaderClassNames}>
                          <Breadcrumbs currentLocation={{ text: listTitle }} />
                          <span className="card-tile-header">{listTitle}</span>
                        </h2>
                      </div>
                      <CardTiles
                        cardTileMobileProps={cardTileMobileProps}
                        filteredCards={filteredShortNames}
                      />
                      <LazyScrollMetricTracker
                        startTrackingAfterPznArrival={true}
                        scrollDtm={get(pageData, 'vacDtmMap.sbVacCardTileBottomDtm')}
                      />
                      <KabbageBanner pageData={pageData} />
                    </div>
                  </>
                ) : (
                  <div className="progress-circle-vac">
                    <ProgressCircle styles={ProgressCircleStyles} />
                  </div>
                )}
              </Sticky.Container>
            </div>
            <RABBanner
              content={pageData.reinforcementBanner.content}
              locale="viewAllCards"
              styles={vacRABBannerStyles}
            />
            <SeoCategory data={pageData.seoCategory} />
            <LazyScrollMetricTracker
              scrollDtm={{ ...faqContent?.faqImpressionDTM }}
            />
            <FAQ content={faqContent} styles={faqStyles} />
            <FooterLegalCopy />
            <CardTrayHolder
              onCompareTrayEmptyItemClick={onCompareTrayEmptyItemClick}
            />
            <DcfBanner pageType="business" pageId={pznPageIds.businessCardsV2} />
            <ApplyByPhoneButton />
            <SuppCardsModal
              showSuppCardsModal={showSuppModal}
              toggle={handleToggleSuppModal}
              dtmElement={'hero'}
              dtmPage={'vac'}
            />
          </div>
        </ModalButtonRefContext.Provider>
      </DynamicAppModalContext.Provider>
    </div>
  );
});

const mapDispatchToProps = dispatch => {
  return {
    addCardToCompare: shortName => dispatchAddCardToCompare(dispatch, { shortName }),
    setCardsInCompareTray: () => dispatchPreselectedCardsArrived(dispatch),
    removeCardFromCompare: shortName =>
      dispatchRemoveCardFromCompare(dispatch, { shortName })
  };
};

const mapStateToProps = state => {
  return {
    cardShortNames: getMemberCardShortNames(state),
    bauFilterCards: getActiveFilterCards(state),
    bauActiveFilterLabel: getActiveFilterLabel(state),
    cmVACTerms: get(state, 'businessCardsV2.TNL.cmVACTerms.content'),
    selectedCards: getSelectedCompareCards(state),
    comparedCards: getCardListData(state),
    isCmLoggedIn: isUserLoggedIn(state),
    G148: getOneXpExperiments(state)['GCS-148-AA-TEST'],
    pznSpecialOfferDtmInfo: getPznSpecialOfferDtmInfo(state),
    dynAppModalContent: getDynAppModalContent(state),
    shouldShowDynamicApp: shouldShowDynamicAppVac(state),
    staticOrderCards: getPageFeatureFlags(state).useStaticOrderForCardTiles,
    pznArrived: hasPznDataArrived(state),
    isG169: isG169Variant(state),
    g174ActiveCards: getG174ActiveFilterCards(state),
    isG174: isG174Experiment(state),
    g174ActiveLabel: getG174ActiveFilterLabel(state),
    isG176: isG176Variant(state)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessCreditCardsTemplate);
